import { Instagram, Music2, ArrowUpRight, BadgeCheck } from "lucide-react";
import { useReveal } from "../lib/useReveal";
import { useTilt } from "../lib/useTilt";

const PLACEHOLDER_DR =
  "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'><rect width='200' height='200' fill='%23141414'/><text x='100' y='132' font-family='Outfit,sans-serif' font-weight='300' font-size='84' fill='%23fafafa' text-anchor='middle'>DR</text></svg>";

const PLACEHOLDER_D =
  "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'><rect width='200' height='200' fill='%23141414'/><text x='100' y='138' font-family='Outfit,sans-serif' font-weight='300' font-size='110' fill='%23fafafa' text-anchor='middle'>D</text></svg>";

const roster = [
  {
    name: "Don Arlo",
    handle: "@donarloo",
    platform: "TikTok",
    platformIcon: Music2,
    category: "Creator · Viral Entertainment",
    followers: "58K+",
    description:
      "A fast-moving TikTok creator focused on viral internet culture, entertainment, and audience-first content.",
    image:
      "https://customer-assets.emergentagent.com/job_creator-elite-4/artifacts/vrz2qdj0_donarloo",
    link: "https://www.tiktok.com/@donarloo",
    badge: "TikTok",
  },
  {
    name: "Olivia Kayo",
    handle: "@olivia.kayo",
    platform: "TikTok",
    platformIcon: Music2,
    category: "Creator · Lifestyle & Fashion",
    followers: "60K+",
    description:
      "A TikTok creator with a fast-growing, aesthetic-driven brand across lifestyle, fashion, and everyday-life content.",
    image:
      "https://customer-assets.emergentagent.com/job_creator-elite-4/artifacts/epws2y9a_Screenshot%202026-05-27%20at%2010.58.56%E2%80%AFAM.png",
    link: "https://www.tiktok.com/@olivia.kayo",
    badge: "TikTok",
  },
  {
    name: "Ballz to the Wallz",
    handle: "@ballztothewallz89",
    platform: "TikTok",
    platformIcon: Music2,
    category: "Creator · Entertainment",
    followers: "100K+",
    description:
      "A TikTok creator with a fast-growing audience across entertainment, personality-driven content, and viral culture.",
    image:
      "https://customer-assets-agu9un31.emergentagent.net/job_creator-elite-4/artifacts/5ho7hzsg_Screenshot%202026-07-18%20at%202.17.13%E2%80%AFPM.png",
    link: "https://www.tiktok.com/@ballztothewallz89",
    badge: "TikTok",
  },
  {
    name: "Brodz",
    handle: "@itzbrodycoyle",
    platform: "TikTok",
    platformIcon: Music2,
    category: "Creator · Entertainment",
    followers: "50K+",
    description:
      "A TikTok creator with a fast-growing audience across entertainment, lifestyle, and personality-driven short-form content.",
    image:
      "https://customer-assets-agu9un31.emergentagent.net/job_creator-elite-4/artifacts/v02e2dhi_Screenshot%202026-07-29%20at%2012.38.39%E2%80%AFPM.png",
    link: "https://www.tiktok.com/@itzbrodycoyle",
    badge: "TikTok",
  },
  {
    name: "Outta Pocket Network",
    handle: "@outtapocketnews",
    platform: "Instagram",
    platformIcon: Instagram,
    category: "Viral Media · Satirical News",
    followers: "600K+",
    description:
      "A large-scale Instagram media brand built around viral headlines, internet culture, and high-engagement social content.",
    image:
      "https://customer-assets.emergentagent.com/job_creator-elite-4/artifacts/18g63tga_outtapocketnews",
    link: "https://www.instagram.com/outtapocketnews/",
    badge: "Instagram",
  },
  {
    name: "My Quote Diary",
    handle: "@myquotediary_",
    platform: "TikTok",
    platformIcon: Music2,
    category: "Creator · Quotes & Aesthetic",
    followers: "280K+",
    description:
      "A fast-growing TikTok page building a strong community around quotes, captions, and mood-driven aesthetic storytelling.",
    image:
      "https://customer-assets.emergentagent.com/job_creator-elite-4/artifacts/t1ejcek8_Screenshot%202026-05-16%20at%2010.43.00%E2%80%AFPM.png",
    link: "https://www.tiktok.com/@myquotediary_",
    badge: "TikTok",
  },
  {
    name: "Joshua Gomez",
    handle: "@joshuaxgomez",
    platform: "TikTok",
    platformIcon: Music2,
    category: "Creator · Lifestyle",
    followers: "15K+",
    description:
      "A TikTok creator with a fast-growing, personality-driven brand across lifestyle, everyday culture, and short-form content.",
    image:
      "https://customer-assets.emergentagent.com/job_creator-elite-4/artifacts/gp9jz7nb_Screenshot%202026-06-16%20at%2012.28.41%E2%80%AFPM.png",
    link: "https://www.tiktok.com/@joshuaxgomez",
    badge: "TikTok",
  },
  {
    name: "Thoughts Painted Red",
    handle: "@thoughtspaintedred",
    platform: "TikTok",
    platformIcon: Music2,
    category: "Creator · Aesthetic / Internet Culture",
    followers: "516K+",
    description:
      "A fast-growing TikTok creator with a distinctive, moody aesthetic and a strong community built around mood-driven internet culture.",
    image:
      "https://customer-assets.emergentagent.com/job_creator-elite-4/artifacts/0rip46qo_Screenshot%202026-05-10%20at%207.41.55%E2%80%AFPM.png",
    link: "https://www.tiktok.com/@thoughtspaintedred",
    badge: "TikTok",
  },
  {
    name: "Loganepes",
    handle: "@logan_epes",
    platform: "TikTok",
    platformIcon: Music2,
    category: "Creator · Lifestyle",
    followers: "12K+",
    description:
      "A TikTok creator building a fast-growing brand across lifestyle, culture, and personality-driven short-form content.",
    image:
      "https://customer-assets-agu9un31.emergentagent.net/job_creator-elite-4/artifacts/2ycnuwau_Screenshot%202026-08-19%20at%2012.10.53%E2%80%AFAM.png",
    link: "https://www.tiktok.com/@logan_epes",
    badge: "TikTok",
  },
  {
    name: "Drew's World",
    handle: "@drewastro1",
    platform: "TikTok",
    platformIcon: Music2,
    category: "Creator · Entertainment",
    followers: "50K+",
    description:
      "A TikTok creator building a fast-growing, character-driven brand across entertainment, comedy, and internet-native culture.",
    image:
      "https://customer-assets.emergentagent.com/job_creator-elite-4/artifacts/uwsiosf8_Screenshot%202026-05-11%20at%204.50.04%E2%80%AFPM.png",
    link: "https://www.tiktok.com/@drewastro1",
    badge: "TikTok",
  },
  {
    name: "iRob Nxt Door",
    handle: "@irobnxtdoor",
    platform: "TikTok",
    platformIcon: Music2,
    category: "Creator · Lifestyle",
    followers: "21K+",
    description:
      "A TikTok creator building a fast-growing audience across lifestyle, personality-driven content, and everyday culture.",
    image:
      "https://customer-assets.emergentagent.com/job_creator-elite-4/artifacts/jl92fb3t_Screenshot%202026-06-01%20at%203.34.22%E2%80%AFPM.png",
    link: "https://www.tiktok.com/@irobnxtdoor",
    badge: "TikTok",
  },
  {
    name: "Aj",
    handle: "@aj41805",
    platform: "TikTok",
    platformIcon: Music2,
    category: "Creator · Lifestyle",
    followers: "6K+",
    description:
      "A TikTok creator building an organic, personality-driven brand across lifestyle, culture, and short-form content.",
    image:
      "https://customer-assets-agu9un31.emergentagent.net/job_creator-elite-4/artifacts/k14f0l67_Screenshot%202026-08-19%20at%2012.16.38%E2%80%AFAM.png",
    link: "https://www.tiktok.com/@aj41805",
    badge: "TikTok",
  },
  {
    name: "Michel Jerome",
    handle: "@micheal_jerome",
    platform: "TikTok",
    platformIcon: Music2,
    category: "Creator · Lifestyle",
    followers: "5K+",
    description:
      "An emerging TikTok creator building an organic, personality-driven feed across lifestyle, culture, and everyday-life content.",
    image:
      "https://customer-assets.emergentagent.com/job_creator-elite-4/artifacts/eryu0q6l_Screenshot%202026-05-09%20at%209.42.38%E2%80%AFPM.png",
    link: "https://www.tiktok.com/@micheal_jerome",
    badge: "TikTok",
  },
  {
    name: "Reaction Farmers",
    handle: "@reactionfarmers",
    platform: "Instagram",
    platformIcon: Instagram,
    category: "Viral Media · Reactions",
    followers: "14K+",
    description:
      "An Instagram media page building a fast-growing community around viral reactions, internet culture, and engagement-driven content.",
    image:
      "https://customer-assets-agu9un31.emergentagent.net/job_creator-elite-4/artifacts/49lre6k8_Screenshot%202026-08-19%20at%2012.23.37%E2%80%AFAM.png",
    link: "https://www.instagram.com/reactionfarmers/",
    badge: "Instagram",
  },
  {
    name: "Goodbye Stranger",
    handle: "@gdbystr",
    platform: "TikTok",
    platformIcon: Music2,
    category: "Creator · Aesthetic",
    followers: "195K+",
    description:
      "A fast-growing TikTok page building a strong community around mood-driven aesthetic, minimal typography, and internet-native storytelling.",
    image:
      "https://customer-assets-agu9un31.emergentagent.net/job_creator-elite-4/artifacts/uverjzxm_Screenshot%202026-08-27%20at%2010.55.31%E2%80%AFAM.png",
    link: "https://www.tiktok.com/@gdbystr",
    badge: "TikTok",
  },
  {
    name: "Williamswagio",
    handle: "@williamswagio",
    platform: "TikTok",
    platformIcon: Music2,
    category: "Creator · Entertainment",
    followers: "600K+",
    description:
      "A large-scale TikTok creator with a fast-growing brand across entertainment, personality-driven content, and viral culture.",
    image:
      "https://customer-assets-agu9un31.emergentagent.net/job_creator-elite-4/artifacts/xmoygbzz_Screenshot%202026-08-11%20at%202.48.09%E2%80%AFPM.png",
    link: "https://www.tiktok.com/@williamswagio",
    badge: "TikTok",
  },
];

const RosterCard = ({ creator, index }) => {
  const ref = useReveal();
  const tiltRef = useTilt({ max: 5, scale: 1.015 });
  const PlatformIcon = creator.platformIcon;
  const slug = creator.name.toLowerCase().replace(/\s+/g, "-");

  return (
    <div ref={ref} style={{ transitionDelay: `${index * 120}ms` }} className="reveal">
      <a
        ref={tiltRef}
        href={creator.link}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={`roster-card-${slug}`}
        className="group relative flex flex-col rounded-[20px] border border-white/10 bg-[#0c0c0c] hover:border-white/30 transition-[border-color,background-color] duration-500 p-7 md:p-8 overflow-hidden border-shine will-change-transform"
        style={{ transformStyle: "preserve-3d" }}
      >
      {/* Soft top-right glow on hover */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -top-24 -right-24 h-64 w-64 rounded-full bg-white/[0.06] blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-700"
      />

      <div className="flex items-start justify-between">
        <span className="inline-flex items-center gap-1.5 rounded-full border border-white/15 bg-white/5 px-3 py-1 text-[11px] uppercase tracking-[0.18em] text-neutral-300">
          <PlatformIcon className="h-3 w-3" strokeWidth={1.5} />
          {creator.badge}
        </span>
        <ArrowUpRight
          className="h-5 w-5 text-neutral-500 group-hover:text-white group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"
          strokeWidth={1.5}
        />
      </div>

      {/* Profile image */}
      <div className="mt-8 flex justify-center">
        <div className="relative">
          <div
            aria-hidden="true"
            className="absolute -inset-2 rounded-full bg-white/5 blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500"
          />
          <div className="relative h-28 w-28 md:h-32 md:w-32 rounded-full p-[2px] bg-gradient-to-b from-white/40 to-white/5">
            <div className="h-full w-full rounded-full overflow-hidden bg-black">
              <img
                src={creator.image}
                alt={`${creator.name} profile`}
                loading="lazy"
                className="h-full w-full object-cover group-hover:scale-105 transition-all duration-700"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Name + handle */}
      <div className="mt-7 text-center">
        <div className="flex items-center justify-center gap-1.5">
          <h3 className="font-display text-2xl md:text-[1.7rem] font-medium tracking-tight text-white">
            {creator.name}
          </h3>
          <BadgeCheck className="h-4 w-4 text-white/70" strokeWidth={1.5} />
        </div>
        <div className="mt-1 text-sm text-neutral-400 font-body">{creator.handle}</div>
        <div className="mt-2 text-[11px] uppercase tracking-[0.22em] text-neutral-500">
          {creator.category}
        </div>
      </div>

      {/* Description */}
      <p className="mt-5 text-sm md:text-[15px] text-neutral-400 leading-relaxed text-center">
        {creator.description}
      </p>

      {/* Footer line */}
      <div className="mt-7 pt-5 border-t border-white/10 flex items-center justify-between">
        <div>
          <div className="text-[10px] uppercase tracking-[0.22em] text-neutral-500">
            Followers
          </div>
          <div className="font-display text-lg font-medium text-white tracking-tight">
            {creator.followers}
          </div>
        </div>
        <div className="text-right">
          <div className="text-[10px] uppercase tracking-[0.22em] text-neutral-500">
            Platform
          </div>
          <div className="font-display text-lg font-medium text-white tracking-tight">
            {creator.platform}
          </div>
        </div>
      </div>
    </a>
    </div>
  );
};

export const Roster = () => {
  const headRef = useReveal();
  return (
    <section
      id="roster"
      data-testid="roster-section"
      className="relative bg-[#050505] py-24 md:py-32 border-t border-white/5 overflow-hidden"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute top-0 left-1/2 -translate-x-1/2 h-[32rem] w-[32rem] rounded-full bg-white/[0.05] blur-3xl float-slow pulse-glow"
      />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div ref={headRef} className="reveal flex flex-col items-center text-center mb-16 md:mb-20">
          <span className="text-xs uppercase tracking-[0.28em] text-neutral-500 font-medium">
            04 / The Roster
          </span>
          <h2
            data-testid="roster-heading"
            className="mt-6 font-display text-5xl sm:text-6xl md:text-7xl font-light tracking-tighter leading-[1.02]"
          >
            OUR <span className="italic font-medium">Roster</span>
          </h2>
          <p className="mt-6 max-w-xl text-base md:text-lg text-neutral-400">
            Creators and media brands shaping internet culture.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
          {roster.map((c, i) => (
            <RosterCard key={c.name} creator={c} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Roster;

